import axios from "axios";

// Public storefront reads only. No API token here: anything in REACT_APP_*
// is baked into the public JS bundle, so these requests rely on the Strapi
// "Public" role permissions instead (find/findOne on storefront content).
export const makeRequest = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});
